import {
  NonEditableComponentTypes,
  UnsupportedComponentTypes,
} from 'src/interfaces/ComponentTypesList';

import { CODForm } from './cod/CODForm';
import { CODThankYouForm } from './codThankyou/CODThankYouForm';
import { ComboStyleForm } from './comboStyle/ComboStyleForm';
import { DisclaimerForm } from './disclaimer/Disclaimer';
import { useFormSelectorState } from './FormSelector.hook';
import { FormSelectorProps } from './FormSelector.interface';
import { ListingWithOptionalVisualsForm } from './listingWithOptionalVisuals/ListingWithOptionalVisuals';
import { ListingVisualGalleryForm } from './listingWithVisualGallery/ListingVisualGalleryForm';
import { PromotionalSpaceForm } from './promotionalSpace/PromotionalSpaceForm';
import { SingleShelfForm } from './singleShelf/SingleShelfForm';

export const FormSelector = (props: FormSelectorProps) => {
  const formName = props.selectedComponent.component_type?.name ?? '';
  const { handleComponentChanges } = useFormSelectorState(props);

  if (
    UnsupportedComponentTypes.includes(formName) ||
    NonEditableComponentTypes.includes(formName)
  ) {
    return null;
  }

  return (
    <>
      {formName === 'single-shelf' ? (
        <SingleShelfForm
          componentDetails={props.selectedComponent}
          form={props.form}
          hasTriedSaving={props.hasTriedSaving}
          onSave={props.saveComponentConfig}
          onChange={handleComponentChanges}
        />
      ) : formName === 'listing-with-optional-visuals' ? (
        <ListingWithOptionalVisualsForm
          form={props.form}
          hasTriedSaving={props.hasTriedSaving}
          componentDetails={props.selectedComponent}
          onSave={props.saveComponentConfig}
          onChange={handleComponentChanges}
        />
      ) : formName === 'combo-style' ? (
        <ComboStyleForm
          form={props.form}
          hasTriedSaving={props.hasTriedSaving}
          componentDetails={props.selectedComponent}
          onSave={props.saveComponentConfig}
          onChange={handleComponentChanges}
        />
      ) : formName === 'promotional-space' ||
        formName === 'promotional-component' ? (
        <PromotionalSpaceForm
          form={props.form}
          hasTriedSaving={props.hasTriedSaving}
          componentDetails={props.selectedComponent}
          onSave={props.saveComponentConfig}
          onChange={handleComponentChanges}
        />
      ) : formName === 'listing-visuals-gallery' ? (
        <ListingVisualGalleryForm
          form={props.form}
          hasTriedSaving={props.hasTriedSaving}
          componentDetails={props.selectedComponent}
          onSave={props.saveComponentConfig}
          onChange={handleComponentChanges}
        />
      ) : formName === 'disclaimer' ? (
        <DisclaimerForm
          form={props.form}
          hasTriedSaving={props.hasTriedSaving}
          componentDetails={props.selectedComponent}
          onSave={props.saveComponentConfig}
          onChange={handleComponentChanges}
        />
      ) : formName === 'cod' ? (
        <CODForm
          hasTriedSaving={props.hasTriedSaving}
          componentDetails={props.selectedComponent}
          onSave={props.saveComponentConfig}
          onChange={handleComponentChanges}
          setSize={props.setSize}
          setOrderType={props.setOrderType}
        />
      ) : formName === 'cod-thank-you' ? (
        <CODThankYouForm
          form={props.form}
          hasTriedSaving={props.hasTriedSaving}
          saveToken={props.saveToken}
          componentDetails={props.selectedComponent}
          onSave={props.saveComponentConfig}
          onChange={handleComponentChanges}
        />
      ) : null}
    </>
  );
};
